<template>
  <tk-flex
    v-if="equipments.length === 0"
    class="width-full"
    style="height: 500px"
    middle
    center
  >
    <a-empty></a-empty>
  </tk-flex>
  <tk-flex
    v-else-if="!tagTrusted"
    class="width-full"
    style="height: 500px"
    middle
    center
  >
    <a-empty>
      <span slot="description">数据异常，可能由于通风或摄像头晃动引起异常</span>
    </a-empty>
  </tk-flex>
  <div class="m-t-20" style="background-color: #fff;" v-else>
    <tk-flex center>
      <div style="width: 950px;">
        <a-card
          :loading="isRequestPoint"
          class="m-t-20"
          :bordered="false"
        >
          <ReportForms
            :storeBugNum="storeBugNum"
            :originalList="originalList"
            :time1="testTime"
          >
            <tk-flex class="width-full" center>
              <div class="overflow-hidden" style="width: 60%">
                <a-card
                  :loading="isRequestPoint"
                  size="small"
                  :bordered="false"
                  style="height: 100%;"
                >
                  <div class="bg-white">
                    <tk-flex
                      between
                      middle
                      class="height-full grid bg-white p-x-15 bg-white items-center"
                      style="height: 60px; grid-template-columns: 1fr auto 1fr; gap: 15px"
                    >
                      <div style="font-weight: 600;font-size:16px;">
                        粮虫检测点位图
                      </div>
                      <tk-flex between class="justify-self-end">
                        <tk-flex middle class="m-r-8">
                          <div class="point-tag bug m-r-2"></div>
                          <span>有虫</span>
                        </tk-flex>
                        <tk-flex middle class="m-r-8">
                          <div class="point-tag nobug m-r-2"></div>
                          <span>无虫</span>
                        </tk-flex>
                        <tk-flex middle>
                          <div class="point-tag notest m-r-2"></div>
                          <span>未检测到</span>
                        </tk-flex>
                      </tk-flex>
                    </tk-flex>
                    <div>
                      <PointsList
                        :horizontal="width"
                        :vertical="height"
                        :isCircle="isCircle"
                        :eqPoints="eqPoints"
                        :diameter="isCircle ? storeInfo.diameter : 0"
                      />
                    </div>
                  </div>
                </a-card>
              </div>
            </tk-flex>
          </ReportForms>
        </a-card>
      </div>
    </tk-flex>
  </div>
</template>
<script>
import ReportForms from './reportForms.vue'
import PointsList from './points'
import moment from 'moment'

const squareRoot2 = 1.414

export default {
  props: {
    tagTrusted: {
      type: Boolean,
      required: true
    },
    date: {
      type: Object,
      required: true
    },
    storeInfo: {
      type: Object,
      required: true
    },
    eqPoints: {
      type: Array,
      required: true
    },
    equipments: {
      type: Array,
      required: true
    },
    isRequestPoint: {
      type: Boolean,
      required: true
    },
    pointsRes: {
      type: Array,
      required: true
    },
    storeBugNum: {
      type: Number,
      required: true
    }
  },
  components: {
    ReportForms,
    PointsList
  },
  data () {
    return {
      dataSource: [
        {
          key: '1',
          name: '象甲科（米象、玉米象等）',
          num: '--',
          density: '--'
        },
        {
          key: '2',
          name: '拟步甲科等（谷盗等）',
          num: '--',
          density: '--'
        },
        {
          key: '3',
          name: '飞蚁科',
          num: '--',
          density: '--'
        },
        {
          key: '4',
          name: '飞蛾科',
          num: '--',
          density: '--'
        },
        {
          key: '5',
          name: '飞蛾幼虫类',
          num: '--',
          density: '--'
        },
        {
          key: '6',
          name: '未识别害虫',
          num: '--',
          density: '--'
        },
        {
          key: '7',
          name: '总计',
          num: '--',
          density: '--'
        }
      ],
      columns: [
        {
          title: '粮虫种类',
          dataIndex: 'name',
          key: 'name'
        },
        {
          title: '粮虫数量（只）',
          dataIndex: 'num',
          key: 'num'
        },
        {
          title: '粮虫密度（只/m³）',
          dataIndex: 'density',
          key: 'density'
        }
      ],
      testTime: '--'
    }
  },
  computed: {
    storeId () {
      return this.$route.query.store
    },
    width () {
      if (this.storeInfo.type === 'square') {
        return this.storeInfo.length
      } else if (this.storeInfo.type === 'circle') {
        return this.storeInfo.diameter / squareRoot2
      } else {
        return 0
      }
    },
    height () {
      if (this.storeInfo.type === 'square') {
        return this.storeInfo.width
      } else if (this.storeInfo.type === 'circle') {
        return this.storeInfo.diameter / squareRoot2
      } else {
        return 0
      }
    },
    isCircle () {
      return this.storeInfo.type !== 'square'
    },
    originalList () {
      return this.pointsRes.map((element, index) => ({
        num: index + 1,
        count: element.pass ? 0 : element.count,
        origin: element
      }))
    }
  },
  watch: {
    storeBugNum: {
      immediate: true,
      handler (newV) {
        this.dataSource[this.dataSource.length - 1].num = newV
      }
    }
  },
  methods: {
    async getTestTime () {
      // if (this.date) {
      //   this.testTime = this.date.format('YYYY-MM-DD HH:mm')
      // }
      const res = await this.$tkParse.get('/classes/dayStoreResult', {
        params: {
          where: {
            store: this.storeId,
            date: {
              $gt: moment(this.date)
                .startOf('day')
                .toISOString(),
              $lte: moment(this.date)
                .endOf('day')
                .toISOString()
            }
          }
        }
      })
      const result = res.data.results[0]
      this.testTime = moment(result.date).format('YYYY-MM-DD HH:mm')
    }
  },
  mounted () {
    this.getTestTime()
  }
}
</script>
<style scoped>
::v-deep .ant-card-small > .ant-card-body {
  padding: 0px;
}
.point-tag {
  width: 16px;
  height: 10px;
  border-radius: 2px;
  &.bug {
    background-color: #ffe6bc;
  }
  &.nobug {
    border: 1px solid #dde0e5;
  }
  &.notest {
    background-color: #efeff0;
  }
}
</style>
